(() => {
  if (customElements.get('stx-gift-box')) return;
  const SW_W = 'linear-gradient(160deg,#FBFBFA 0%,#ECECEA 48%,#DCDCDA 100%)';
  const SW_G = 'linear-gradient(160deg,#7A7D82 0%,#5E6166 48%,#4B4E52 100%)';
  const CSS = `stx-gift-box.stxg .stxg__deal{display:flex;align-items:flex-end;justify-content:space-between;gap:16px;padding:14px 2px 2px;border-top:1px solid #E3E3E3}
stx-gift-box.stxg .stxg__deal[hidden]{display:none}
.stxg__deal-l{display:flex;flex-direction:column;gap:4px;min-width:0}
.stxg__deal-k{font-family:"IBM Plex Mono",ui-monospace,monospace;font-size:11px;font-weight:500;letter-spacing:.12em;text-transform:uppercase;color:#272727}
.stxg__deal-s{font-size:14px;color:#404040}
.stxg__deal-s b{font-weight:500;color:#272727}
.stxg__deal-p{flex:none;display:flex;align-items:baseline;gap:10px;line-height:1}
.stxg__deal-p s{font-size:15px;color:#9C9C9C}
.stxg__deal-p b{font-size:28px;font-weight:500;letter-spacing:-.035em;color:#272727}
stx-gift-box.stxg .stxg__tiles{display:flex;flex-direction:column;gap:8px}
stx-gift-box.stxg .stxq__opt{position:relative;border:1px solid #DEDEDE;background:#fff;transition:border-color .2s cubic-bezier(.2,0,0,1),background .2s}
stx-gift-box.stxg .stxq__opt:hover{border-color:#BBBBBB}
stx-gift-box.stxg .stxq__opt.is-on{border-color:#272727;background:#FAFAFA}
stx-gift-box.stxg .stxq__row{display:grid;grid-template-columns:18px minmax(0,1fr) auto;align-items:center;gap:16px;width:100%;padding:16px 18px;border:0;border-radius:0;background:transparent;text-align:left}
.stxq__row *{pointer-events:none}
.stxq__radio{position:relative;width:18px;height:18px;border-radius:50%;border:1px solid #BBBBBB;background:#fff;transition:border-color .15s}
.stxq__radio::after{content:"";position:absolute;inset:4px;border-radius:50%;background:#272727;transform:scale(0);transition:transform .2s cubic-bezier(.2,0,0,1)}
stx-gift-box.stxg .stxq__opt:hover .stxq__radio{border-color:#767676}
stx-gift-box.stxg .stxq__opt.is-on .stxq__radio{border-color:#272727}
stx-gift-box.stxg .stxq__opt.is-on .stxq__radio::after{transform:scale(1)}
.stxq__t{display:flex;align-items:baseline;flex-wrap:wrap;gap:4px 10px;min-width:0}
.stxq__t b{font-size:16px;font-weight:500;line-height:1.2;letter-spacing:-.01em;color:#272727}
.stxq__t span{font-size:13px;color:#767676}
.stxq__t i{font-style:normal;font-family:"IBM Plex Mono",ui-monospace,monospace;font-size:10px;font-weight:500;letter-spacing:.1em;text-transform:uppercase;color:#272727;padding:3px 6px;border:1px solid #D1D1D1}
stx-gift-box.stxg .stxq__opt.is-on .stxq__t i{border-color:#272727}
.stxq__p{display:flex;align-items:baseline;gap:8px;line-height:1.15}
.stxq__p b{font-size:16px;font-weight:500;letter-spacing:-.01em;color:#272727}
.stxq__p s{font-size:13px;color:#9C9C9C}
.stxq__fins{margin:0 18px;padding:2px 0 8px;border-top:1px solid #E6E6E6;animation:stxq-in .24s cubic-bezier(.16,1,.3,1)}
@keyframes stxq-in{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}
.stxq__unit{display:flex;align-items:center;gap:14px;padding:6px 0}
.stxq__unit + .stxq__unit{border-top:1px solid #F0F0F0}
.stxq__num{flex:none;width:58px;font-size:13px;color:#767676}
stx-gift-box.stxg .stxg__sws{gap:6px}
stx-gift-box.stxg .stxg__sw{width:34px;height:34px;padding:4px;transform:none}
stx-gift-box.stxg .stxg__sw::before{box-shadow:0 0 0 1px transparent}
stx-gift-box.stxg .stxg__sw:hover{transform:none}
stx-gift-box.stxg .stxg__sw span,stx-gift-box.stxg .stxg__sw:hover span,stx-gift-box.stxg .stxg__sw.is-on span{box-shadow:inset 0 0 0 1px rgba(39,39,39,.14)}
stx-gift-box.stxg .stxg__sw:hover::before{box-shadow:0 0 0 1px #D1D1D1}
stx-gift-box.stxg .stxg__sw.is-on::before{box-shadow:0 0 0 1px #272727}
stx-gift-box.stxg .stxq__fins .stxg__fin{margin-left:auto;font-size:14px;color:#404040}
stx-gift-box.stxg .stxq__opt .stxg__flag{top:-9px;right:14px}
stx-gift-box.stxg .stxg__foot{display:flex;align-items:center;justify-content:center;gap:14px;margin:-4px 0 2px;font-size:10px;font-weight:500;letter-spacing:.16em;color:#5D5D5D}
stx-gift-box.stxg .stxg__foot b{display:none}
stx-gift-box.stxg .stxg__up-img{width:72px;height:72px;background:#E9E9E9}
stx-gift-box.stxg .stxg__up-img img{object-fit:cover;mix-blend-mode:multiply}
stx-gift-box.stxg .stxg__up-copy{gap:3px}
stx-gift-box.stxg .stxg__up-copy b{font-size:15px;font-weight:500;letter-spacing:-.01em}
stx-gift-box.stxg .stxg__up-s2{font-size:13px;line-height:1.4;color:#767676}
stx-gift-box.stxg .stxg__up.is-on .stxg__up-s2{color:#272727;font-weight:500}
stx-gift-box.stxg .stxg__up-p{flex:none;display:flex;flex-direction:column;align-items:flex-end;gap:6px;font-size:13px;font-weight:500}
@media (max-width:420px){stx-gift-box.stxg .stxq__row{gap:12px;padding:14px}stx-gift-box.stxg .stxq__fins{margin:0 14px}.stxq__num{width:50px}.stxg__deal-p b{font-size:24px}stx-gift-box.stxg .stxg__up-img{width:60px;height:60px}}`;
  class StxGiftBox extends HTMLElement {
    connectedCallback() {
      if (this._init) return; this._init = true;
      if (!document.getElementById('stxg-x-css')) { const s = document.createElement('style'); s.id = 'stxg-x-css'; s.textContent = CSS; document.body.appendChild(s); }
      const J = s => { const el = this.querySelector(s); return el ? JSON.parse(el.textContent) : []; };
      const all = J('[data-variants]');
      all.forEach(v => { v.color = /white/i.test(v.title) ? SW_W : SW_G; });
      this.variants = all.filter(v => v.available); if (!this.variants.length) this.variants = all;
      this.tiers = J('[data-tiers]');
      const fl = (this.tiers.find(t => t.flag) || {}).flag;
      this.tiers.forEach(t => { t.flag = ''; });
      if (fl && this.tiers[1]) this.tiers[1].flag = fl;
      this.bundle = J('[data-bundle]')[0] || null;
      if (this.bundle && !(this.bundle.variants || []).length) this.bundle = null;
      const cur = this.dataset.currency || 'USD', loc = this.dataset.locale || 'en';
      try { const f0 = new Intl.NumberFormat(loc, { style: 'currency', currency: cur, maximumFractionDigits: 0 }), f2 = new Intl.NumberFormat(loc, { style: 'currency', currency: cur, minimumFractionDigits: 2, maximumFractionDigits: 2 }); this.fmt = n => (Math.round(n * 100) % 100 ? f2 : f0).format(n); }
      catch (e) { this.fmt = n => '$' + n.toFixed(Math.round(n * 100) % 100 ? 2 : 0); }
      const v0 = this.variants[0], v1 = this.variants[1] || v0;
      this.picks = [v0.id, v1.id, v0.id];
      this.up = false;
      this.n = Math.min(this.tiers.length, Math.max(1, +this.dataset.default || 2));
      this.main = document.querySelector(this.dataset.mainImg || '[data-stx-main] img');
      const fr = this.querySelector('[data-finish-root]');
      if (fr) { const l = fr.previousElementSibling; if (l && l.classList.contains('stxg__lbl')) l.remove(); fr.remove(); }
      const lbl = this.querySelector('.stxg__lbl'); if (lbl) lbl.innerHTML = '<b>How many</b><span>Choose finish</span>';
      const cta = this.querySelector('[data-act="add"]');
      this.deal = document.createElement('div'); this.deal.className = 'stxg__deal'; this.deal.setAttribute('aria-live', 'polite');
      cta.parentNode.insertBefore(this.deal, cta);
      const foot = this.querySelector('.stxg__foot'); if (foot) cta.insertAdjacentElement('afterend', foot);
      this.addEventListener('click', e => this.onClick(e));
      this.render();
    }
    onClick(e) {
      const t = e.target.closest('[data-act]'); if (!t || !this.contains(t)) return;
      e.preventDefault();
      const a = t.dataset.act, i = +t.dataset.i;
      if (a === 'tier') { if (this.n === +t.dataset.n) return; this.n = +t.dataset.n; }
      else if (a === 'swatch') { this.picks[i] = +t.dataset.id; this.img(i); }
      else if (a === 'upgrade-one') { this.up = !this.up; this.img(0); }
      else if (a === 'add') return this.add();
      this.render();
    }
    isB(i) { return this.up && !!this.bundle && i === 0; }
    bv(standId) { if (!this.bundle) return null; const s = this.v(standId); return this.bundle.variants.find(b => b.key === s.key) || this.bundle.variants[0]; }
    img(i) { if (!this.main) return; const s = this.v(this.picks[i]), src = this.isB(i) ? (this.bv(s.id).img || s.img) : s.img; if (src) { this.main.removeAttribute('srcset'); this.main.src = src; } }
    unit(i, pct) { const s = this.v(this.picks[i]); const full = this.isB(i) ? this.bv(s.id).price : s.price; return { full, now: Math.round(full * (100 - pct) / 100) }; }
    m(c) { return this.fmt(c / 100); }
    v(id) { return this.variants.find(x => x.id === id) || this.variants[0]; }
    esc(s) { return String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }
    finsHtml() {
      let h = '';
      for (let i = 0; i < this.n; i++) {
        const cur = this.v(this.picks[i]);
        h += `<div class="stxq__unit"><span class="stxq__num">Stand ${i + 1}</span><div class="stxg__sws" role="radiogroup" aria-label="Stand ${i + 1} finish">${this.variants.map(v => `<button type="button" role="radio" aria-checked="${v.id === cur.id}" aria-label="Stand ${i + 1}: ${this.esc(v.title)}" title="${this.esc(v.title)}" class="stxg__sw${v.id === cur.id ? ' is-on' : ''}" data-act="swatch" data-i="${i}" data-id="${v.id}"><span style="background:${v.color}"></span></button>`).join('')}</div><span class="stxg__fin">${this.esc(cur.title.split('|')[0].trim())}${this.isB(i) ? '<em>+ Keyboard + mouse</em>' : ''}</span></div>`;
      }
      return `<div class="stxq__fins">${h}</div>`;
    }
    render() {
      const t = this.tiers[this.n - 1], up = this.up && !!this.bundle;
      const sBase = this.v(this.picks[0]).price;
      let total = 0, full = 0;
      for (let i = 0; i < this.n; i++) { const u = this.unit(i, t.pct); total += u.now; full += u.full; }
      this.querySelector('[data-tiers-root]').innerHTML = this.tiers.map(x => {
        const on = x.n === this.n, each = Math.round(sBase * (100 - x.pct) / 100);
        const tot = on ? total : each * x.n, fl = on ? full : sBase * x.n;
        return `<div class="stxq__opt${on ? ' is-on' : ''}">
          <button type="button" role="radio" aria-checked="${on}" class="stxq__row" data-act="tier" data-n="${x.n}">
            <span class="stxq__radio" aria-hidden="true"></span>
            <span class="stxq__t"><b>${x.n} ${x.n === 1 ? 'Stand' : 'Stands'}</b>${x.pct ? `<i>Save ${x.pct}%</i>` : ''}<span>${this.m(each)} each</span></span>
            <span class="stxq__p">${fl > tot ? `<s>${this.m(fl)}</s>` : ''}<b>${this.m(tot)}</b></span>
          </button>
          ${x.flag ? `<span class="stxg__flag">${this.esc(x.flag)}</span>` : ''}
          ${on ? this.finsHtml() : ''}
        </div>`;
      }).join('');
      const root = this.querySelector('[data-upgrade-root]');
      if (root) {
        root.hidden = !this.bundle;
        if (this.bundle) {
          const bvar = this.bv(this.picks[0]);
          const add = Math.round((bvar.price - sBase) * (100 - t.pct) / 100);
          const img = bvar.img || this.dataset.kbImg || '';
          const sub = up ? 'Added \u2014 ships with Stand 1' : 'Make it the full Peak Performance setup';
          root.innerHTML = `<button type="button" role="switch" aria-checked="${up}" class="stxg__up${up ? ' is-on' : ''}" data-act="upgrade-one">
            <span class="stxg__chk" aria-hidden="true"></span>
            <span class="stxg__up-img">${img ? `<img src="${this.esc(img)}" alt="Model-X stand with CMD-X keyboard and mouse" loading="lazy">` : ''}</span>
            <span class="stxg__up-copy">
              <b>Add the CMD-X keyboard + mouse</b>
              <span class="stxg__up-s2">${sub}</span>
            </span>
            <span class="stxg__up-p"><span>+${this.m(add)}</span></span>
          </button>`;
        }
      }
      const nx = this.tiers[this.n], saved = full - total;
      const sub = saved > 0 ? `You save <b>${this.m(saved)}</b> \u00b7 ${t.pct}% off` : nx ? `Add 1 more and save ${nx.pct}%` : '';
      this.deal.innerHTML = `<span class="stxg__deal-l"><span class="stxg__deal-k">Total</span>${sub ? `<span class="stxg__deal-s">${sub}</span>` : ''}</span><span class="stxg__deal-p">${full > total ? `<s>${this.m(full)}</s>` : ''}<b>${this.m(total)}</b></span>`;
      const btn = this.querySelector('[data-act="add"]');
      if (!btn.disabled) btn.innerHTML = `<span>Add to cart</span><span></span>`;
      const hint = this.querySelector('[data-hint]'); if (hint) hint.textContent = '';
    }
    async add() {
      const btn = this.querySelector('[data-act="add"]'), err = this.querySelector('[data-error]'), map = new Map();
      for (let i = 0; i < this.n; i++) { const id = this.isB(i) ? this.bv(this.picks[i]).id : this.picks[i]; map.set(id, (map.get(id) || 0) + 1); }
      btn.disabled = true; btn.textContent = 'Adding\u2026'; err.hidden = true;
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      try {
        const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [...map].map(([id, quantity]) => ({ id, quantity })) }) });
        if (!r.ok) { let d = {}; try { d = await r.json(); } catch (_) {} throw new Error(d.description || d.message || 'Could not add to cart'); }
        const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
        btn.disabled = false; this.render();
        if (customElements.get('stx-cart')) { window.dispatchEvent(new CustomEvent('stx:cart-open', { detail: { cart } })); document.querySelectorAll('[data-stx-cart-count]').forEach(n => { n.textContent = cart.item_count; }); }
        else window.location.href = root + 'cart';
      } catch (e) { err.textContent = e.message; err.hidden = false; btn.disabled = false; this.render(); }
    }
  }
  customElements.define('stx-gift-box', StxGiftBox);
})();
